<ng-container *ngIf="render">
    <editor [init]="settings" [formControl]="editorFormControl"></editor>
</ng-container>
